/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EventResponseRecordsInnerDefinition } from './EventResponseRecordsInnerDefinition';
import {
    EventResponseRecordsInnerDefinitionFromJSON,
    EventResponseRecordsInnerDefinitionFromJSONTyped,
    EventResponseRecordsInnerDefinitionToJSON,
} from './EventResponseRecordsInnerDefinition';
import type { EventResponseRecordsInnerEvent } from './EventResponseRecordsInnerEvent';
import {
    EventResponseRecordsInnerEventFromJSON,
    EventResponseRecordsInnerEventFromJSONTyped,
    EventResponseRecordsInnerEventToJSON,
} from './EventResponseRecordsInnerEvent';

/**
 * 
 * @export
 * @interface EventResponseRecordsInner
 */
export interface EventResponseRecordsInner {
    /**
     * 
     * @type {EventResponseRecordsInnerDefinition}
     * @memberof EventResponseRecordsInner
     */
    definition?: EventResponseRecordsInnerDefinition;
    /**
     * 
     * @type {EventResponseRecordsInnerEvent}
     * @memberof EventResponseRecordsInner
     */
    event?: EventResponseRecordsInnerEvent;
}

/**
 * Check if a given object implements the EventResponseRecordsInner interface.
 */
export function instanceOfEventResponseRecordsInner(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EventResponseRecordsInnerFromJSON(json: any): EventResponseRecordsInner {
    return EventResponseRecordsInnerFromJSONTyped(json, false);
}

export function EventResponseRecordsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventResponseRecordsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'definition': !exists(json, 'definition') ? undefined : EventResponseRecordsInnerDefinitionFromJSON(json['definition']),
        'event': !exists(json, 'event') ? undefined : EventResponseRecordsInnerEventFromJSON(json['event']),
    };
}

export function EventResponseRecordsInnerToJSON(value?: EventResponseRecordsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'definition': EventResponseRecordsInnerDefinitionToJSON(value.definition),
        'event': EventResponseRecordsInnerEventToJSON(value.event),
    };
}

